// hooks/useSignalRListener.js
import { useEffect, useRef } from "react";
import { useSignalRContext } from "./signalRProvider";

/**
 * Suscribe un handler a un evento del hub. Los handlers de HubConnection sobreviven a las
 * reconexiones, así que se registra una vez por conexión y se quita al desmontar.
 */
export const useSignalRListener = (eventName, handler) => {
    const { connection } = useSignalRContext();
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        if (!connection) return;

        const listener = (...args) => handlerRef.current(...args);
        connection.on(eventName, listener);
        return () => {
            connection.off(eventName, listener);
        };
    }, [connection, eventName]);
};
